import type { BuildingUsersTranslations } from "../../types/buildingUsers";

export const buildingUsers: BuildingUsersTranslations = {
  subtitle:
    "Hallake oma hoone meeskonna kontakte. Lisage meeskonnaliikmeid, t\u00F6\u00F6v\u00F5tjaid ja sidusgruppe.",
  addContact: "Lisa kontakt",
  searchPlaceholder: "Otsi nime, e-posti, telefoni v\u00F5i ettev\u00F5tte j\u00E4rgi...",
  filterByCompany: "Filtreeri ettev\u00F5tte j\u00E4rgi",
  allCompanies: "K\u00F5ik ettev\u00F5tted",
  contactsCount: "{count} kontakti",
  companiesCount: "{count} ettev\u00F5tet",
  loading: "Meeskonna laadimine...",
  name: "Nimi",
  contact: "Kontakt",
  company: "Ettev\u00F5te",
  actions: "Tegevused",
  removeTitle: "Eemalda kontakt",
  removeConfirm:
    "Kas olete kindel, et soovite eemaldada {name} meeskonnast? Seda toimingut ei saa tagasi v\u00F5tta.",
  removeContact: "Eemalda kontakt",
  contactRemoved: "Kontakt eemaldatud",
  contactRemovedDesc: "Kontakt on meeskonnast eemaldatud.",
  removeFailed: "Kontakti eemaldamine eba\u00F5nnestus. Palun proovige uuesti.",
  loadError: "Meeskonna laadimine eba\u00F5nnestus",
  noContacts: "Kontakte ei leitud",
  noContactsSearch: "Proovige muuta oma otsingu- v\u00F5i filtreerimistingimusi.",
  noContactsEmpty: "\u00DCtegi meeskonnaliiget pole veel lisatud. Lisage kontaktid alustamiseks.",
};
